import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currency: {
    code: '',
    name: '',
    symbol: '',
  },
};

export const createCurrency = createSlice({
  name: 'createCurrency',
  initialState,
  reducers: {
    updateCurrencyInfo: (state, action) => {
      state.currency = action.payload;
    },
    updateCurrencyInfoField: (state, action) => {
      const { field, value } = action.payload;
      state.currency[field] = value;
    },
    clearCurrencyInfo: (state) => {
      state.currency = initialState.currency;
    },
  },
});

export const currencyDetailSelector = (state) => state.createCurrency.currency;
export const {
  updateCurrencyInfo,
  updateCurrencyInfoField,
  clearCurrencyInfo,
} = createCurrency.actions;

export const createCurrencyReducer = createCurrency.reducer;
export const createCurrencyReducerName = createCurrency.name;

export default createCurrency.reducer;
